import { render, staticRenderFns } from "./seaTurtles.vue?vue&type=template&id=15ca575a"
import script from "./seaTurtles.vue?vue&type=script&lang=js"
export * from "./seaTurtles.vue?vue&type=script&lang=js"
import style0 from "./seaTurtles.vue?vue&type=style&index=0&id=15ca575a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports